import repository from '@/repositories/repository'
import url from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/municipio`

    return {
        autocomplete(queryParms = {}) {
            return repository.get(`${baseUrl}/autocomplete?${url.serialize(queryParms)}`)
        },
    }
}